import request from '../request'

/**
 * SVG 画图文档接口。
 * 文档数据由 svg edit 编辑器产出，后端以 JSON 文件形式落盘。
 */

/**
 * 获取文档列表（仅元信息，不含 svgString）。
 * @returns {Promise<Array>} [{ id, title, width, height, createdAt, updatedAt }]
 */
export function fetchSvgDocList() {
  return request({
    url: '/api/svg-doc/list',
    method: 'GET',
  })
}

/**
 * 获取单个文档详情（含完整 svgString）。
 * @param {string} id 文档 id
 * @returns {Promise<Object>} { id, title, svgString, createdAt, updatedAt }
 */
export function fetchSvgDocDetail(id) {
  return request({
    url: `/api/svg-doc/${id}`,
    method: 'GET',
  })
}

/**
 * 新建文档。
 * @param {{title: string, svgString: string}} payload 文档内容
 * @returns {Promise<Object>} 创建后的文档元信息
 */
export function createSvgDoc(payload) {
  return request({
    url: '/api/svg-doc/create',
    method: 'POST',
    data: payload,
  })
}

/**
 * 覆盖保存文档。
 * @param {string} id 文档 id
 * @param {{title: string, svgString: string}} payload 文档内容
 * @returns {Promise<Object>} 保存后的文档元信息
 */
export function updateSvgDoc(id, payload) {
  return request({
    url: `/api/svg-doc/${id}`,
    method: 'PUT',
    data: payload,
  })
}

/**
 * 删除文档。
 * @param {string} id 文档 id
 * @returns {Promise<Object>} 被删除的文档元信息
 */
export function deleteSvgDoc(id) {
  return request({
    url: `/api/svg-doc/${id}`,
    method: 'DELETE',
  })
}
